import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Paintbrush, HardHat, Compass } from 'lucide-react';
const services = [{
  icon: Building2,
  title: 'Architecture Design',
  description: 'Designing buildings that balance form, function, and environmental performance across residential and commercial projects.',
  initialY: 200
}, {
  icon: Paintbrush,
  title: 'Interior Design',
  description: 'Thoughtful interior environments shaped through space planning, lighting, and material selection.',
  initialY: 160
}, {
  icon: Compass,
  title: 'Project Management',
  description: 'Full project oversight to ensure delivery on schedule, within budget, and to the highest standards.',
  initialY: 120
}, {
  icon: HardHat,
  title: 'Construction Management',
  description: 'Careful coordination from groundbreaking to completion, ensuring quality and minimizing risk at every stage.',
  initialY: 80
}];
export function ServicesSection() {
  return <section id="services" className="py-24 md:py-32 bg-bg-light relative" data-id="element-194">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-195">
        {/* Section label - left aligned */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex items-center space-x-4 mb-6" data-id="element-196">
          <span className="h-px w-12 bg-accent block" data-id="element-197"></span>
          <span className="text-accent uppercase tracking-widest text-sm font-light" data-id="element-198">
            Our Expertise
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-tight tracking-normal mb-4" data-id="element-199">
          Architectural <span className="text-accent" data-id="element-200">Services</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-text-muted text-lg font-light mb-16 md:mb-0" data-id="element-201">
          Comprehensive architectural services from concept to completion.
        </motion.p>

        {/* Staggered grid aligned to scroll grid columns */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-x-12 lg:gap-x-20 md:mt-24" data-id="element-202">
          {services.map((service, index) => <div key={index} className="px-0" data-id="element-203">
              <motion.div initial={{
            opacity: 0,
            y: service.initialY
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 1,
            delay: index * 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="py-8 md:py-0" data-id="element-204">
                <div className="text-accent mb-6" data-id="element-205">
                  <service.icon size={24} strokeWidth={1.5} data-id="element-206" />
                </div>

                <h3 className="text-sm uppercase tracking-widest text-text-muted font-light mb-4" data-id="element-207">
                  {service.title}
                </h3>

                <p className="text-base md:text-lg lg:text-xl font-light text-primary leading-snug tracking-normal mb-6" data-id="element-208">
                  {service.description}
                </p>

                <div className="h-px w-full bg-neutral-200 mt-auto" data-id="element-209" />
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}